import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';

type Props = {
  show: boolean;
  onHide: () => void;
};

type State = {
  show: boolean;
};

export class TimeSavingFeaturesModal extends React.Component<Props, {}> {
  state: State  = {
    show: this.props.show
  };

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      show: nextProps.show
    });
  }

  handleClose = () => {
    this.props.onHide();
  }

  render() {
    console.log('Time saving features is rendering....');
    if (!this.state.show) {
      return null;
    }

    return (
      <Modal show={this.state.show} onHide={this.handleClose}>
        <Modal.Header closeButton style={{ backgroundColor: '#337ab7', color: '#fff' }}>
          <Modal.Title>Time Saving Features</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Save time during the data entry process by not having to enter values for markers that
            can be easily calculated.
          </p>
          <b>Auto-Calculated Fields</b>
          <p>
            The values for the following markers are automatically calculated after the values
            needed for their calculations are entered.  They can be overridden.
          </p>
          <p>
            <table className="auto-calculated-fields">
              <tbody>
                <tr>
                  <td>
                    <ul>
                      <li>MCV (Mean Corpuscular Volume)</li>
                      <li>MCH (Mean Corpuscular HGB)</li>
                      <li>MCHC (MCH Concentration)</li>
                      <li>BUN/Creatinine Ratio</li>
                      <li>Globulin</li>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <li>A/G Ratio</li>
                      <li>Bilirubin, Direct and Indirect</li>
                      <li>Cholesterol/HDL Ratio</li>
                      <li>Triglycerides/HDL Ratio</li>
                      <li>% Saturation</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </p>
          <b>WBC Differentials Auto-Calculated Fields</b>
          <p>
            Enter WBC differential data using the % or Absolutes based on the radio
            button selected and the other will be automatically calculated and stored in the 
            database.  Both % and Absolute values will be plotted on bar graphs in the Immune 
            Function Marker Overview panel.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
